import "./less/index.scss";

import ReactDOM from "react-dom/client";
import App from "./App";
import DialogProvider from "./libs/dialog/DialogProvider";
import PathProvider from "./libs/path/PathProvider";
import SnackbarProvider from "./libs/dialog/SnackbarProvider";
import { LoginContextProvider } from "./libs/login/useLogin";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import FoodApi from "./data/FoodApi";
import Usernames from "./libs/login/Usernames";

(async function main(){
  const root = ReactDOM.createRoot(document.getElementById("root")!);

  await FoodApi.i.init()
  Usernames.i.init(FoodApi.i)

  root.render(<SnackbarProvider><PathProvider>
    <DialogProvider><LoginContextProvider api={FoodApi.i} required={false}>
      <App/>
    </LoginContextProvider></DialogProvider>
    </PathProvider></SnackbarProvider>);

  serviceWorkerRegistration.register()
})()
